import { render, staticRenderFns } from "./data-cell.vue?vue&type=template&id=6f1c450a&scoped=true&"
import script from "./data-cell.vue?vue&type=script&lang=js&"
export * from "./data-cell.vue?vue&type=script&lang=js&"
import style0 from "./data-cell.vue?vue&type=style&index=0&id=6f1c450a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1c450a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/daniel/work/jiangxi/fed-sd-visual-web-static/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f1c450a')) {
      api.createRecord('6f1c450a', component.options)
    } else {
      api.reload('6f1c450a', component.options)
    }
    module.hot.accept("./data-cell.vue?vue&type=template&id=6f1c450a&scoped=true&", function () {
      api.rerender('6f1c450a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/temporary/home/components/data-cell.vue"
export default component.exports